import { render } from "./FlowForm.vue?vue&type=template&id=5b84f4b8"
import script from "./FlowForm.vue?vue&type=script&lang=js"
export * from "./FlowForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__